/**
 * Locale constants with no runtime dependencies. Kept apart from `config.ts`
 * (which reads `process.env`) so components that only need the locale list, such
 * as `text.ts`, stay type-checkable in packages without Node types.
 */

/**
 * Locales the platform knows about. `en-XA` is the pseudo-locale used to spot
 * untranslated or truncated strings in QA; it never gets a URL prefix.
 */
export const LOCALES = ['en', 'es', 'fr', 'en-XA'] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';
export const PSEUDO_LOCALE: Locale = 'en-XA';

const LOCALE_SET: ReadonlySet<string> = new Set(LOCALES);

export const isLocale = (value: unknown): value is Locale =>
  typeof value === 'string' && LOCALE_SET.has(value);
